import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Flex } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
var cardStyle = {
  border: '1px solid var(--chakra-colors-lightGrey2)',
  boxShadow: '0px 0px 12px  var(--chakra-colors-lightGrey4)',
  borderRadius: '3px',
  bgColor: 'baseWhite'
};
export default function Card(_ref) {
  var children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return _jsx(Flex, _objectSpread(_objectSpread(_objectSpread({}, cardStyle), otherProps), {}, {
    p: otherProps.padding || 'md',
    children: children
  }));
}